export const version = '2.6.16';
//# sourceMappingURL=version.js.map